import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeveloperBuild = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.66668 14C2.30001 14 1.98612 13.8694 1.72501 13.6083C1.4639 13.3472 1.33334 13.0333 1.33334 12.6667V3.33333C1.33334 2.96667 1.4639 2.65278 1.72501 2.39167C1.98612 2.13056 2.30001 2 2.66668 2H12C12.3667 2 12.6806 2.13056 12.9417 2.39167C13.2028 2.65278 13.3333 2.96667 13.3333 3.33333V4.66667H14.6667V6H13.3333V7.33333H14.6667V8.66667H13.3333V10H14.6667V11.3333H13.3333V12.6667C13.3333 13.0333 13.2028 13.3472 12.9417 13.6083C12.6806 13.8694 12.3667 14 12 14H2.66668ZM4.00001 11.3333H7.33334V8.66667H4.00001V11.3333ZM8.00001 6.66667H10.6667V4.66667H8.00001V6.66667ZM4.00001 8H7.33334V4.66667H4.00001V8ZM8.00001 11.3333H10.6667V7.33333H8.00001V11.3333Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDeveloperBuild);
export default ForwardRef;
